document.addEventListener("DOMContentLoaded", () => {
  const bodyPaintFinal = document.querySelector("#body-paint-final");
  const mechanicalFinal = document.querySelector("#mechanical-final");

  const resultOk = document.querySelector("#overall-result-ok");
  const resultRedo = document.querySelector("#overall-result-redo");
  const resultPending = document.querySelector("#overall-result-pending");
  const passedInput = document.querySelector("#quality-check-passed");

  if (
    !bodyPaintFinal ||
    !mechanicalFinal ||
    !resultOk ||
    !resultRedo ||
    !resultPending ||
    !passedInput
  ) {
    return;
  }

  const updateOverallResult = () => {
    const bodyPaintValue = bodyPaintFinal.querySelector('input[type="radio"]:checked')?.value;
    const mechanicalValue = mechanicalFinal.querySelector('input[type="radio"]:checked')?.value;

    resultOk.classList.add("hidden");
    resultRedo.classList.add("hidden");
    resultPending.classList.add("hidden");

    passedInput.value = "";

    if (bodyPaintValue === undefined || mechanicalValue === undefined) {
      resultPending.classList.remove("hidden");
      return;
    }

    if (bodyPaintValue === "true" && mechanicalValue === "true") {
      resultOk.classList.remove("hidden");
      passedInput.value = "true";
    } else {
      resultRedo.classList.remove("hidden");
      passedInput.value = "false";
    }
  };

  bodyPaintFinal.addEventListener("change", updateOverallResult);
  mechanicalFinal.addEventListener("change", updateOverallResult);

  updateOverallResult();
});
